var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "eu-px_3 eu-pb_5" },
    [
      !!_vm.firstTransaction.qr_code_url
        ? _c("PixFirstTransaction", {
            attrs: {
              "charge-id": _vm.chargeId,
              "qr-code-url": _vm.firstTransaction.qr_code_url,
            },
          })
        : _c("div", [_vm._v("-")]),
      _c("div", { staticClass: "eu-mt_4" }, [
        _c(
          "p",
          { staticClass: "emd-text _color_default _type_caption eu-mb_1" },
          [
            _vm._v(
              " " +
                _vm._s(_vm.$t("charge.detail.payment-method.pix.expire-at")) +
                " "
            ),
          ]
        ),
        _c("p", [
          _vm._v(
            _vm._s(
              _vm._f("dateFormat")(_vm.firstTransaction.expires_at, "date")
            )
          ),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }